export default {"src":"/_next/static/media/university.5d4e1e0b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};